import React from "react";
import { toast } from "react-toastify";
import Button from "../../../main/components/Button";
import { trpc } from "../../../main/components/trpc.ts";

interface PatientStateCommentEditProps {
  comment: string;
  patientId: string;
  stateId: number | null;
  onClose: () => void;
}

const PatientStateCommentEdit = (props: PatientStateCommentEditProps) => {
  const [comment, setComment] = React.useState<string>(props.comment);
  const utils = trpc.useUtils();
  const patientStateMutation = trpc.patient.commitPatientState.useMutation({
    onSettled: async (_data, error) => {
      if (error) {
        return;
      }
      await utils.patient.getStatesByIds.invalidate();
      await utils.patient.getPatientsEnCours.invalidate();
      props.onClose();
    },
    onError: () => {
      toast.error("Impossible d'enregistrer le commentaire.");
    },
  });
  const onCommentSubmit = () => {
    patientStateMutation.mutate({
      patientId: props.patientId,
      stateId: props.stateId,
      state: {
        comment,
      },
    });
  };
  return (
    <div className="w-96">
      <textarea
        className="w-full h-32 border border-gray-300 rounded p-2"
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        disabled={patientStateMutation.isPending}
      />
      <Button
        title={patientStateMutation.isPending ? "Enregistrement..." : "Enregistrer"}
        onClick={onCommentSubmit}
        disabled={patientStateMutation.isPending}
      />
    </div>
  );
};

export default PatientStateCommentEdit;
